var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScreenshot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.83333V4.16667C2.5 3.72464 2.67559 3.30072 2.98816 2.98816C3.30072 2.67559 3.72464 2.5 4.16667 2.5H5.83333",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1666 2.5H15.8333C16.2753 2.5 16.6992 2.67559 17.0118 2.98816C17.3244 3.30072 17.5 3.72464 17.5 4.16667V5.83333",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 14.167V15.8337C17.5 16.2757 17.3244 16.6996 17.0118 17.0122C16.6992 17.3247 16.2753 17.5003 15.8333 17.5003H14.1666",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 17.5003H4.16667C3.72464 17.5003 3.30072 17.3247 2.98816 17.0122C2.67559 16.6996 2.5 16.2757 2.5 15.8337V14.167",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3334 6.66699H6.66671C6.20647 6.66699 5.83337 7.04009 5.83337 7.50033V12.5003C5.83337 12.9606 6.20647 13.3337 6.66671 13.3337H13.3334C13.7936 13.3337 14.1667 12.9606 14.1667 12.5003V7.50033C14.1667 7.04009 13.7936 6.66699 13.3334 6.66699Z",
    stroke: "#282D38",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScreenshot);
export default __webpack_public_path__ + "static/media/screenshot.0269c8bf1bfeadf70a94f126f9dbb7cc.svg";
export { ForwardRef as ReactComponent };